import instance from './axiosInstance';

export function getAlertsSummaryData(reqBody, options = {}, http = instance) {
  return http.get('/ai-alerts/summary', reqBody, options);
}

export function getAlertsSummaryDataWithPagination(reqBody, options = {}, http = instance) {
  return http.post('/ai-alerts/dpi', reqBody, options);
}

function getAlertsByRootCauseWithPagination(reqBody, options = {}, http = instance) {
  return http.post('/ai-alerts/dpi/root-cause', reqBody, options);
}

export function getAlertDiagnosticsData(reqBody, options = {}, http = instance) {
  return http.get('/ai-alerts/diagnostics', reqBody, options);
}

function getSensitivity(reqBody, options = {}, http = instance) {
  const res = http.get('/ai-alerts/sensitivity', reqBody, options);
  return res;
}

function getLegacySensitivity(reqBody, options = {}, http = instance) {
  const res = http.get('/ai-alerts/sensitivity/v2/legacy-metrics', reqBody, options);
  return res;
}

function getSensitivityLogs(reqBody = {}, options = {}, http = instance) {
  return http.get('/ai-alerts/sensitivityLogs', reqBody, options);
}

function saveSensitivityDataForMetric(reqBody, options = {}, http = instance) {
  return http.post('/ai-alerts/sensitivity', reqBody, options);
}

function saveLegacySensitivityDataForMetric(reqBody, options = {}, http = instance) {
  return http.post('/ai-alerts/sensitivity/v2/legacy-metrics', reqBody, options);
}

function getConfigList(reqBody = {}, options = {}, http = instance) {
  return http.get('/ai-alerts/dimension-combination', reqBody, options);
}

function updateConfigList(reqBody = {}, options = {}, http = instance) {
  return http.post('/ai-alerts/dimension-combination', reqBody, options);
}

function getConfigListForMetric(reqBody = {}, options = {}, http = instance) {
  return http.post('/ai-alerts/dimension-combination/list', reqBody, options);
}

function updateConfigListForMetric(reqBody = {}, options = {}, http = instance) {
  return http.post('/ai-alerts/dimension-combination/edit', reqBody, options);
}

function getConfigChangelog(reqBody = {}, options = {}, http = instance) {
  return http.get('/ai-alerts/synopsis-changelog', reqBody, options);
}

function getDimensionMapping(reqBody = {}, options = {}, http = instance) {
  return http.get('/ai-alerts/dimension-mapping', reqBody, options);
}

export {
  getSensitivity,
  saveLegacySensitivityDataForMetric,
  getLegacySensitivity,
  getSensitivityLogs,
  saveSensitivityDataForMetric,
  getConfigList,
  updateConfigList,
  updateConfigListForMetric,
  getConfigChangelog,
  getDimensionMapping,
  getAlertsByRootCauseWithPagination,
  getConfigListForMetric,
};
